import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { SiteFooter } from '@/components/layout/SiteFooter';

interface AppLayoutProps {
  children: ReactNode;
}

// Routes where the global Navigation bar and SiteFooter are hidden.
// These pages use their own internal sidebar layout (LearnerLayout, EnterpriseSidebar, AdminSidebar).
// ⚠️ Any new dashboard-style route MUST be added here to avoid double navigation.
const LAYOUT_HIDDEN_SEGMENTS = [
  // Admin NoCodeo
  '/admin', 
  // Enterprise admin
  '/enterprise', 
  '/organization',
  // Learner dashboard pages
  '/dashboard', 
  '/my-formations', 
  '/progress', 
  '/billing', 
  '/mes-documents', 
  '/quiz-history', 
  '/support',
  '/profile',
  '/certificates',
  '/documents',
  // Course engine (full-screen, has its own nav)
  '/course'
];

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  
  const isAdminPage = LAYOUT_HIDDEN_SEGMENTS.some(segment => 
    location.pathname.startsWith(segment)
  );

  // Pages with full-width layout (no restrictive wrapper)
  const isFullWidthPage = ['/', '/about', '/conseil', '/contact', '/cas-clients', '/tarifs', '/blog'].includes(location.pathname) || location.pathname.startsWith('/blog/');

  return (
    <div className="min-h-screen bg-background">
      {!isAdminPage && <Navigation />}
      {isAdminPage ? children : (
        <>
          {isFullWidthPage ? (
            <div className="pt-24">
              {children}
            </div>
          ) : (
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pt-24">
              {children}
            </main>
          )}
          <SiteFooter />
        </>
      )}
    </div>
  );
}
